<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="M&aacute;y in đa năng CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655">
     M&aacute;y in đa năng CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_vi" title="Th&ocirc;ng tin an to&agrave;n">
     Th&ocirc;ng tin an to&agrave;n
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Quy ước">
      Quy ước
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="Tuy&ecirc;n bố về sản phẩm">
      Tuy&ecirc;n bố về sản phẩm
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_vi" title="T&igrave;m hiểu về m&aacute;y in">
     T&igrave;m hiểu về m&aacute;y in
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_vi" title="T&igrave;m th&ocirc;ng tin về m&aacute;y in">
      T&igrave;m th&ocirc;ng tin về m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_vi" title="T&igrave;m số s&ecirc;-ri của m&aacute;y in">
      T&igrave;m số s&ecirc;-ri của m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_vi" title="Cấu h&igrave;nh m&aacute;y in">
      Cấu h&igrave;nh m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_vi" title="Sử dụng bảng điều khiển">
      Sử dụng bảng điều khiển
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_vi" title="Biểu tượng tr&ecirc;n m&agrave;n h&igrave;nh ch&iacute;nh">
      Biểu tượng tr&ecirc;n m&agrave;n h&igrave;nh ch&iacute;nh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_vi" title="M&agrave;u đ&egrave;n b&aacute;o">
      M&agrave;u đ&egrave;n b&aacute;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_vi" title="Sử dụng khay nạp t&agrave;i liệu tự động v&agrave; k&iacute;nh m&aacute;y qu&eacute;t">
      Sử dụng khay nạp t&agrave;i liệu tự động v&agrave; k&iacute;nh m&aacute;y qu&eacute;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_vi" title="Định vị khe bảo mật">
      Định vị khe bảo mật
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="Chọn giấy">
      Chọn giấy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10635" title="C&aacute;c t&iacute;nh năng v&agrave; hỗ trợ m&aacute;y in bổ sung">
      C&aacute;c t&iacute;nh năng v&agrave; hỗ trợ m&aacute;y in bổ sung
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_vi" title="Thiết lập, c&agrave;i đặt, v&agrave; thiết lập cấu h&igrave;nh">
     Thiết lập, c&agrave;i đặt, v&agrave; thiết lập cấu h&igrave;nh
    </a>
   </p>
   <div id="divd0e10762">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_vi" title="Chọn vị tr&iacute; cho m&aacute;y in">
      Chọn vị tr&iacute; cho m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_vi" title="C&aacute;c cổng m&aacute;y in">
      C&aacute;c cổng m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10961" title="Thiết lập cấu h&igrave;nh ứng dụng v&agrave; giải ph&aacute;p">
      Thiết lập cấu h&igrave;nh ứng dụng v&agrave; giải ph&aacute;p
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11138" title="Thiết lập v&agrave; sử dụng c&aacute;c t&iacute;nh năng trợ năng">
      Thiết lập v&agrave; sử dụng c&aacute;c t&iacute;nh năng trợ năng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11443" title="C&agrave;i đặt m&aacute;y in để gửi fax">
      C&agrave;i đặt m&aacute;y in để gửi fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_vi" title="Nạp giấy v&agrave; giấy chuy&ecirc;n dụng">
      Nạp giấy v&agrave; giấy chuy&ecirc;n dụng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12239" title="C&agrave;i đặt v&agrave; cập nhật phần mềm, tr&igrave;nh điều khiển v&agrave; phần mềm cơ sở">
      C&agrave;i đặt v&agrave; cập nhật phần mềm, tr&igrave;nh điều khiển v&agrave; phần mềm cơ sở
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12565" title="C&agrave;i đặt t&ugrave;y chọn phần cứng">
      C&agrave;i đặt t&ugrave;y chọn phần cứng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14096" title="Kết nối mạng">
      Kết nối mạng
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_vi" title="Bảo vệ m&aacute;y in">
     Bảo vệ m&aacute;y in
    </a>
   </p>
   <div id="divd0e14448">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_vi" title="X&oacute;a bộ nhớ m&aacute;y in">
      X&oacute;a bộ nhớ m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_vi" title="X&oacute;a ổ lưu trữ m&aacute;y in">
      X&oacute;a ổ lưu trữ m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_vi" title="Kh&ocirc;i phục c&agrave;i đặt mặc định gốc">
      Kh&ocirc;i phục c&agrave;i đặt mặc định gốc
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_vi" title="B&aacute;o c&aacute;o biến động">
      B&aacute;o c&aacute;o biến động
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_vi" title="In">
     In
    </a>
   </p>
   <div id="divd0e14640">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_vi" title="In từ m&aacute;y t&iacute;nh">
      In từ m&aacute;y t&iacute;nh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691" title="In từ thiết bị di động">
      In từ thiết bị di động
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_vi" title="In từ ổ flash">
      In từ ổ flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_vi" title="Đặt cấu h&igrave;nh lệnh in bảo mật">
      Đặt cấu h&igrave;nh lệnh in bảo mật
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_vi" title="In c&aacute;c lệnh b&iacute; mật v&agrave; lệnh tạm dừng kh&aacute;c">
      In c&aacute;c lệnh b&iacute; mật v&agrave; lệnh tạm dừng kh&aacute;c
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_vi" title="In danh s&aacute;ch mẫu ph&ocirc;ng chữ">
      In danh s&aacute;ch mẫu ph&ocirc;ng chữ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_vi" title="In danh s&aacute;ch thư mục">
      In danh s&aacute;ch thư mục
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_vi" title="Đặt trang ph&acirc;n c&aacute;ch trong lệnh in">
      Đặt trang ph&acirc;n c&aacute;ch trong lệnh in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_vi" title="Hủy lệnh in">
      Hủy lệnh in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_vi" title="Điều chỉnh độ tối của mực">
      Điều chỉnh độ tối của mực
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_vi" title="Sao ch&eacute;p">
     Sao ch&eacute;p
    </a>
   </p>
   <div id="divd0e15186">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_vi" title="Sao ch&eacute;p">
      Sao ch&eacute;p
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_vi" title="Sao ch&eacute;p ảnh">
      Sao ch&eacute;p ảnh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_vi" title="Sao ch&eacute;p tr&ecirc;n giấy ti&ecirc;u đề">
      Sao ch&eacute;p tr&ecirc;n giấy ti&ecirc;u đề
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_vi" title="Sao ch&eacute;p tr&ecirc;n cả hai mặt giấy">
      Sao ch&eacute;p tr&ecirc;n cả hai mặt giấy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_vi" title="Thu nhỏ hoặc ph&oacute;ng to bản sao">
      Thu nhỏ hoặc ph&oacute;ng to bản sao
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_vi" title="in bản sao theo bộ">
      in bản sao theo bộ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_vi" title="Đặt trang ph&acirc;n c&aacute;ch giữa c&aacute;c bản sao">
      Đặt trang ph&acirc;n c&aacute;ch giữa c&aacute;c bản sao
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_vi" title="Sao ch&eacute;p nhiều trang v&agrave;o một trang">
      Sao ch&eacute;p nhiều trang v&agrave;o một trang
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_vi" title="Sao ch&eacute;p thẻ">
      Sao ch&eacute;p thẻ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_vi" title="Tạo ph&iacute;m tắt sao ch&eacute;p">
      Tạo ph&iacute;m tắt sao ch&eacute;p
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_vi" title="Email">
     Email
    </a>
   </p>
   <div id="divd0e15459">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_vi" title="Thiết lập cấu h&igrave;nh c&agrave;i đặt SMTP">
      Thiết lập cấu h&igrave;nh c&agrave;i đặt SMTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_vi" title="Gửi email">
      Gửi email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_vi" title="Tạo ph&iacute;m tắt email">
      Tạo ph&iacute;m tắt email
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_vi" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e16908">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_vi" title="Gửi fax">
      Gửi fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_vi" title="L&ecirc;n lịch fax">
      L&ecirc;n lịch fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_vi" title="Tạo ph&iacute;m tắt cho đ&iacute;ch fax">
      Tạo ph&iacute;m tắt cho đ&iacute;ch fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_vi" title="Thay đổi độ ph&acirc;n giải fax">
      Thay đổi độ ph&acirc;n giải fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_vi" title="Điều chỉnh độ tối của fax">
      Điều chỉnh độ tối của fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_vi" title="In nhật k&yacute; fax">
      In nhật k&yacute; fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_vi" title="Chặn fax r&aacute;c">
      Chặn fax r&aacute;c
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_vi" title="Tạm dừng fax">
      Tạm dừng fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_vi" title="Chuyển tiếp fax">
      Chuyển tiếp fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_vi" title="Qu&eacute;t">
     Qu&eacute;t
    </a>
   </p>
   <div id="divd0e17204">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_vi" title="Qu&eacute;t v&agrave;o m&aacute;y t&iacute;nh">
      Qu&eacute;t v&agrave;o m&aacute;y t&iacute;nh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_vi" title="Qu&eacute;t đến m&aacute;y chủ FTP">
      Qu&eacute;t đến m&aacute;y chủ FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_vi" title="Tạo ph&iacute;m tắt FTP">
      Tạo ph&iacute;m tắt FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_vi" title="Qu&eacute;t đến thư mục mạng">
      Qu&eacute;t đến thư mục mạng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_vi" title="Thiết lập cấu h&igrave;nh điểm đ&iacute;ch thư mục mạng">
      Thiết lập cấu h&igrave;nh điểm đ&iacute;ch thư mục mạng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_vi" title="Tạo ph&iacute;m tắt thư mục mạng">
      Tạo ph&iacute;m tắt thư mục mạng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_vi" title="Qu&eacute;t v&agrave;o ổ flash">
      Qu&eacute;t v&agrave;o ổ flash
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_vi" title="Menu m&aacute;y in">
     Menu m&aacute;y in
    </a>
   </p>
   <div id="divd0e17493">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_vi" title="Sơ đồ menu">
      Sơ đồ menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17807" title="Thiết bị">
      Thiết bị
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20041" title="In">
      In
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21323" title="Giấy">
      Giấy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21655" title="Sao ch&eacute;p">
      Sao ch&eacute;p
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22214" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24081" title="Email">
      Email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25178" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25884" title="Ổ USB">
      Ổ USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26730" title="Mạng/cổng">
      Mạng/cổng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28881" title="Bảo mật">
      Bảo mật
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29978" title="Dịch vụ đ&aacute;m m&acirc;y">
      Dịch vụ đ&aacute;m m&acirc;y
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30035" title="B&aacute;o c&aacute;o">
      B&aacute;o c&aacute;o
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_vi" title="Khắc phục sự cố">
      <strong>
       Khắc phục sự cố
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_vi" title="Hợp nhất biểu mẫu">
      <strong>
       Hợp nhất biểu mẫu
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_vi" title="In Trang c&agrave;i đặt menu">
      In
      <strong>
       Trang c&agrave;i đặt menu
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_vi" title="T&ugrave;y chọn bộ ho&agrave;n thiện m&aacute;y in">
     T&ugrave;y chọn bộ ho&agrave;n thiện m&aacute;y in
    </a>
   </p>
   <div id="divd0e30518">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_vi" title="Sử dụng bộ ho&agrave;n thiện dập ghim">
      Sử dụng bộ ho&agrave;n thiện dập ghim
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_vi" title="Sử dụng bộ ho&agrave;n thiện dập ghim, dập lỗ">
      Sử dụng bộ ho&agrave;n thiện dập ghim, dập lỗ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_vi" title="Sử dụng ngăn xếp offset">
      Sử dụng ngăn xếp offset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_vi" title="Sử dụng bộ ho&agrave;n thiện tập s&aacute;ch">
      Sử dụng bộ ho&agrave;n thiện tập s&aacute;ch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_vi" title="Sử dụng t&ugrave;y chọn vận chuyển giấy kết hợp với gấp giấy">
      Sử dụng t&ugrave;y chọn vận chuyển giấy kết hợp với gấp giấy
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_vi" title="Bảo tr&igrave; m&aacute;y in">
     Bảo tr&igrave; m&aacute;y in
    </a>
   </p>
   <div id="divd0e30928">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_vi" title="Kiểm tra trạng th&aacute;i của c&aacute;c bộ phận v&agrave; vật tư">
      Kiểm tra trạng th&aacute;i của c&aacute;c bộ phận v&agrave; vật tư
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_vi" title="Đặt cấu h&igrave;nh th&ocirc;ng b&aacute;o vật tư">
      Đặt cấu h&igrave;nh th&ocirc;ng b&aacute;o vật tư
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_vi" title="Thiết lập cảnh b&aacute;o email">
      Thiết lập cảnh b&aacute;o email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_vi" title="Tạo b&aacute;o c&aacute;o v&agrave; nhật k&yacute;">
      Tạo b&aacute;o c&aacute;o v&agrave; nhật k&yacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_vi" title="Đặt mua c&aacute;c bộ phận v&agrave; vật tư">
      Đặt mua c&aacute;c bộ phận v&agrave; vật tư
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31783" title="Thay thế c&aacute;c bộ phận v&agrave; vật tư">
      Thay thế c&aacute;c bộ phận v&agrave; vật tư
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32407" title="Vệ sinh c&aacute;c bộ phận của m&aacute;y in">
      Vệ sinh c&aacute;c bộ phận của m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32571" title="Tiết kiệm năng lượng v&agrave; giấy">
      Tiết kiệm năng lượng v&agrave; giấy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_vi" title="Di chuyển m&aacute;y in đến vị tr&iacute; kh&aacute;c">
      Di chuyển m&aacute;y in đến vị tr&iacute; kh&aacute;c
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_vi" title="Khắc phục sự cố">
     Khắc phục sự cố
    </a>
   </p>
   <div id="divd0e32709">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_vi" title="Sự cố chất lượng in">
      Sự cố chất lượng in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_vi" title="M&atilde; lỗi m&aacute;y in">
      M&atilde; lỗi m&aacute;y in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_vi" title="Sự cố in">
      Sự cố in
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_vi" title="M&aacute;y in kh&ocirc;ng phản hồi">
      M&aacute;y in kh&ocirc;ng phản hồi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_vi" title="Kh&ocirc;ng thể đọc ổ flash">
      Kh&ocirc;ng thể đọc ổ flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_vi" title="Bật cổng USB">
      Bật cổng USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_vi" title="Xử l&yacute; kẹt giấy">
      Xử l&yacute; kẹt giấy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36133" title="Sự cố kết nối mạng">
      Sự cố kết nối mạng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36226" title="Sự cố t&ugrave;y chọn phần cứng">
      Sự cố t&ugrave;y chọn phần cứng
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399" title="Vấn đề về vật tư">
      Vấn đề về vật tư
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36547" title="Sự cố nạp giấy">
      Sự cố nạp giấy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36741" title="Sự cố gửi email">
      Sự cố gửi email
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36796" title="Sự cố fax">
      Sự cố fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37118" title="Sự cố qu&eacute;t">
      Sự cố qu&eacute;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37536" title="Sự cố chất lượng m&agrave;u">
      Sự cố chất lượng m&agrave;u
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_vi" title="Li&ecirc;n hệ bộ phận hỗ trợ kh&aacute;ch h&agrave;ng">
      Li&ecirc;n hệ bộ phận hỗ trợ kh&aacute;ch h&agrave;ng
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_vi" title="T&aacute;i chế v&agrave; thải bỏ">
     T&aacute;i chế v&agrave; thải bỏ
    </a>
   </p>
   <div id="divd0e37762">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_vi" title="T&aacute;i chế sản phẩm Lexmark">
      T&aacute;i chế sản phẩm Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_vi" title="T&aacute;i chế bao b&igrave; của Lexmark">
      T&aacute;i chế bao b&igrave; của Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_vi" title="Th&ocirc;ng b&aacute;o">
     Th&ocirc;ng b&aacute;o
    </a>
   </p>
   <div id="divd0e37798">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37801" title="Th&ocirc;ng tin sản phẩm">
      Th&ocirc;ng tin sản phẩm
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37818" title="Th&ocirc;ng b&aacute;o phi&ecirc;n bản">
      Th&ocirc;ng b&aacute;o phi&ecirc;n bản
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_vi" title="Thương hiệu">
      Thương hiệu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_vi" title="Th&ocirc;ng b&aacute;o cấp ph&eacute;p">
      Th&ocirc;ng b&aacute;o cấp ph&eacute;p
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_vi" title="Mức độ ph&aacute;t ra tiếng ồn">
      Mức độ ph&aacute;t ra tiếng ồn
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37916" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_vi" title="Thải bỏ sản phẩm">
      Thải bỏ sản phẩm
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_vi" title="Th&ocirc;ng b&aacute;o độ nhạy tĩnh">
      Th&ocirc;ng b&aacute;o độ nhạy tĩnh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_vi" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_vi" title="Th&ocirc;ng tin nhiệt độ">
      Th&ocirc;ng tin nhiệt độ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_vi" title="Th&ocirc;ng b&aacute;o laser">
      Th&ocirc;ng b&aacute;o laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_vi" title="Mức ti&ecirc;u thụ điện">
      Mức ti&ecirc;u thụ điện
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38159" title="Th&ocirc;ng b&aacute;o ph&aacute;p l&yacute; về c&aacute;c sản phẩm kh&ocirc;ng d&acirc;y">
      Th&ocirc;ng b&aacute;o ph&aacute;p l&yacute; về c&aacute;c sản phẩm kh&ocirc;ng d&acirc;y
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_vi" title="Th&ocirc;ng b&aacute;o th&agrave;nh phần m&ocirc;-đun">
      Th&ocirc;ng b&aacute;o th&agrave;nh phần m&ocirc;-đun
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_vi" title="Tiếp x&uacute;c với bức xạ tần số v&ocirc; tuyến">
      Tiếp x&uacute;c với bức xạ tần số v&ocirc; tuyến
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_vi" title="Th&ocirc;ng b&aacute;o nhiễu s&oacute;ng v&ocirc; tuyến">
      Th&ocirc;ng b&aacute;o nhiễu s&oacute;ng v&ocirc; tuyến
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue